import { IconProps } from '@chakra-ui/react';
import { StorageType } from '@diamond/shared/types';
import React from 'react';

import {
  ChilledStorageIcon,
  DryAcStorageIcon,
  DryStorageIcon,
  FrozenStorageIcon,
} from './icons';

export const STORAGE_CONFIG: Record<
  StorageType,
  { icon: React.ComponentType<IconProps>; color: string; label: string }
> = {
  frozen: { icon: FrozenStorageIcon, color: '#007AFF', label: 'Frozen' },
  chilled: { icon: ChilledStorageIcon, color: '#007AFF', label: 'Chilled' },
  dry: { icon: DryStorageIcon, color: '#34C759', label: 'Dry' },
  dry_ac: { icon: DryAcStorageIcon, color: '#34C759', label: 'Dry AC' },
};
